import { Observable } from 'rxjs';

import { Consent } from '../Model/Consent/consent';

export const defaultConsent: Consent = {
    version: '1.0.0',
    isGiven: false,
    hasBeenPrompted: false
};

export abstract class ConsentRepository {
    abstract getConsent(): Observable<Consent>;

    abstract setConsent(consent: Consent): Promise<void>;
}
